module.exports = __webpack_public_path__ + "static/media/22b.65431b27.jpg";